import { Block } from 'baseui/block';
// types
import { ISP_AirDuct } from './types'
// components
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { ValuePanelIcon as TemperaturPanel } from '../../Devices/SensorAnalog'
import { LoadingView } from "../../../components";
// api
import { TrendPanel } from './TrendPanel';
import { AirDuctIcon } from './AirDuctIcon';
import { useStyletron } from 'baseui';
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';
import { useMemo } from 'react';
import { HorizontalStackPanel } from '../../../components/Layout/StackPanel';

export function OverviewPanel(props: ISP_AirDuct) {
    const [css,theme] = useStyletron();
    const { children: childElements, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId,props.id)

    const temperature = useMemo(() =>childElements?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.TemperatureSensor"),[childElements]);
    const humidity = useMemo(() =>childElements?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.HumiditySensor"),[childElements]);
    const pressure = useMemo(() =>childElements?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.PressureSensor"),[childElements]);


    return (
        <OverviewPanelWrapper includeAlarmsFromChildren {...props} icon={<AirDuctIcon color={theme.colors.backgroundPrimary}></AirDuctIcon>}>
            <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
                <>
                    <HorizontalStackPanel  $width={'100%'} $alignItems={'center'} $gap={theme.sizing.scale200}>
                        {temperature &&

                            <TemperaturPanel {...temperature}></TemperaturPanel>
                        }
                        {humidity &&

                            <TemperaturPanel {...humidity}></TemperaturPanel>

                        }
                        {pressure &&

                            <TemperaturPanel {...pressure}></TemperaturPanel>
                        }

                    </HorizontalStackPanel>
                    <TrendPanel temperature={temperature} humidity={humidity} pressure={pressure} />
                </>
            </LoadingView>
        </OverviewPanelWrapper>
    );
}